import { render, staticRenderFns } from "./allow-list.vue?vue&type=template&id=0f6e3243&scoped=true"
import script from "./allow-list.vue?vue&type=script&lang=js"
export * from "./allow-list.vue?vue&type=script&lang=js"
import style0 from "./allow-list.vue?vue&type=style&index=0&id=0f6e3243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6e3243",
  null
  
)

export default component.exports